export default "__VITE_ASSET__v4gsLfZ6__"